import script from "./NotificationsMunicipality.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsMunicipality.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsMunicipality.vue?vue&type=style&index=0&id=f69338a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f69338a4"]])

export default __exports__